/**
 * EventListContainer
 * --
 */
import React, { useEffect, useReducer, useState } from 'react';
import EventListPresenter from './EventListPresenter';
import {
  useGetEvents,
  useCreateEvent,
  useUpdateEvent,
  useDeleteEvent,
  useUpsertEvent,
} from 'hooks/EventHooks';
import { useUserStack } from 'store';
import { useFileUpload } from 'hooks/FileHooks';
import MessageAlert from 'utils';
import Formatter from 'utils/Formatter';

const EventListContainer = () => {
  /* ===== ROUTE ===== */

  /* ===== MUTATE ===== */
  const userInfo = useUserStack();
  const { createEvent } = useCreateEvent();
  const { updateEvent } = useUpdateEvent();
  const { deleteEvent } = useDeleteEvent();
  const { fileUpload } = useFileUpload();
  const { upsertEvent } = useUpsertEvent();

  /* ===== DATA ===== */
  const { data: Events, refetch } = useGetEvents();

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  // 모달
  const [isOpened, setIsOpened] = useState(false);
  // 모달 데이터
  const [modalData, setModalData] = useState({
    event: {},
  });

  const [file, setFile] = React.useState([]);
  // 모달 타입
  const [modalType, setModalType] = useState('read');

  // 전체 선택
  const [isCheckedAll, setIsCheckedAll] = useReducer((state, action) => {
    switch (action.type) {
      case 'TOGGLE':
        return !state;
      case 'RESET':
        return false;
      default:
        return state;
    }
  }, false);
  // 선택 목록
  const [checkedList, setCheckedList] = useState([]);

  // 리패칭
  const [isRefetch, setIsRefetch] = useState(false);

  /* ===== FUNCTION ===== */
  /**
   * 모달창 핸들러
   * --
   */
  const handleModalOpen = (data = {}) => {
    setModalData(data);
    setIsOpened(!isOpened);
  };

  /**
   * 모달 핸들러
   * --
   */
  const handleModal = (open, type = '', data = {}) => {
    setModalData((prev) => ({
      ...prev,
      [type]: data,
    }));
    setFile(
      data?.thumbnail_url
        ? [
            {
              file_url: data?.thumbnail_url,
              created_at: data?.created_at,
            },
          ]
        : []
    );
    setIsOpened(!open);
    setModalType(type);
  };

  /**
   * 체크박스 핸들러
   * --
   * @param { boolean } c
   * @param { object | array } d
   * @param { string } t
   */
  const handleChecked = (c, d, t = null) => {
    if (t) {
      // 전체 선택인 경우
      setCheckedList(d);
    } else {
      // 단일 선택인 경우
      if (c) {
        setCheckedList((prev) => [...prev, d]);
      } else {
        setCheckedList((prev) => prev.filter((item) => item.key !== d.key));
      }
    }
  };

  /**
   * 데이터 바인딩 함수
   * --
   * @param {string} target
   * @param {*} value
   * @param {object} object
   * @param {*} callback
   */
  const handleChange = (t, v, o, callback = null) => {
    let newData = modalData[o];

    newData[t] = v;
    const d = {
      ...modalData,
    };

    setModalData(d);
  };

  /**
   * 선택된 이벤트 사항 삭제
   * --
   */
  const handleDeleteSelected = async () => {
    const eventIds = checkedList.map((item) => item.event_id);

    console.log(eventIds);
    if (checkedList.length === 0) {
      MessageAlert.warning('삭제할 항목을 선택해주세요.');
      return;
    }

    try {
      setIsLoading(true);

      // 선택된 event_id 리스트로 삭제 요청
      const deletePromises = checkedList.map((item) =>
        deleteEvent(item.event_id)
      );

      await Promise.all(deletePromises);

      MessageAlert.success('선택된 이벤트 사항이 삭제되었습니다.');

      // 선택 항목 초기화
      setCheckedList([]);
      // 리패치
      await refetch();
    } catch (err) {
      MessageAlert.error('이벤트 사항 삭제 중 오류가 발생했습니다.');
      console.error('[DELETE EVENT ERROR]:', err);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 데이터 생성/수정
   * --
   * @param {string} t
   * @param {string} s
   * @returns
   */
  console.log('modalData =====>', modalData);
  console.log('file =====>', file);
  const handleSubmit = async (t, s = 'CREATE') => {
    // 생성 타입 대문자 변환
    const type = t.toLocaleUpperCase();
    // 함수 타입 대문자 변환
    const submit = s.toLocaleUpperCase();

    // 생성 타입 정의
    const submitType = {
      EVENT: '이벤트 사항',
      CREATE: '생성',
      UPDATE: '수정',
    };

    // NOTE: 데이터 유효성 검사 및 데이터 리턴
    const data = handleValidateCheck(type);
    if (!data) return;

    // NOTE: 생성/수정 함수 정의
    const submitFunc = {
      EVENT: {
        CREATE: createEvent,
        UPDATE: updateEvent,
      },
    };

    try {
      // 로딩 처리
      setIsLoading(true);

      let thumbnailUrl = modalData?.event?.thumbnail_url;

      if (
        // typeof file !== 'string' &&
        (file?.[0]?.file_url ?? file?.[0]?.name) !== thumbnailUrl &&
        file.length > 0
      ) {
        // 타임스탬프 추가하여 새로운 파일명 생성
        const timestamp = Date.now();
        const fileExtension = file?.[0]?.name?.split('.').pop();
        const baseName = file?.[0]?.name?.replace(`.${fileExtension}`, '');
        const fileName = `jm_coffee/events/${baseName}_${timestamp}.${fileExtension}`;

        // 이전 파일과 다른 경우에만 업로드 진행
        if (thumbnailUrl !== fileName) {
          // 이전 파일 삭제 로직 (필요 시 추가)

          // 새로운 파일 업로드
          const uploadResponse = await fileUpload({
            file: file?.[0],
            file_name: fileName,
          });

          if (uploadResponse?.status !== 200) {
            MessageAlert.error('파일 업로드에 실패했습니다.');
            return;
          }
          // 업로드 성공 시 새로운 thumbnail_url 설정
          thumbnailUrl = fileName;
        }
      }

      // 데이터 생성/수정
      const { status } = await submitFunc[type][submit]({
        event_id: modalData?.event?.event_id,
        thumbnail_url: file.length > 0 ? thumbnailUrl : null,
        ...data,
      });

      // 데이터 업데이트 성공 시
      if (status === 200) {
        MessageAlert.success(
          `성공적으로 ${submitType[type]}이/가 ${submitType[submit]}되었습니다.`
        );
        // 값 초기화
        setModalData((prev) => ({ ...prev, t: {} }));
        // 모달 닫기
        setIsOpened(!isOpened);
        // 리패치
        setIsRefetch(true);

        await refetch();
        return;
      }

      MessageAlert.warning(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 실패하였습니다.`
      );
    } catch (err) {
      MessageAlert.error(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 오류가 발생하였습니다.`
      );
      console.error(`[CREATE ${type}] ERROR : `, err);
      throw err;
    } finally {
      // 로딩 처리
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /**
   * 유효성 검사
   * --
   * @param {string} t
   * @returns
   */
  const handleValidateCheck = (t) => {
    if (t === 'EVENT') {
      // 유효성 검사
      const {
        event_title,
        event_content,
        start_date,
        end_date,
        is_show,
        is_main,
        event_benefit,
        type,
      } = modalData?.event || {};

      // 이벤트 제목 입력값 체크
      if (!event_title) {
        MessageAlert.warning('이벤트 제목을 입력해주세요.');
        return false;
      }

      // 이벤트 내용 입력값 체크
      if (!event_content || event_content === '<p><br></p>') {
        MessageAlert.warning('이벤트 내용를 입력해주세요.');
        return false;
      }

      // 노출여부 체크
      if (!is_show) {
        MessageAlert.warning('노출여부를 선택해주세요.');
        return false;
      }

      // 시작/종료일 체크
      if (!start_date) {
        MessageAlert.warning('시작일을 입력해주세요.');
        return false;
      }
      // 시작/종료일 체크
      if (!end_date) {
        MessageAlert.warning('종료일을 입력해주세요.');
        return false;
      }
      // 메인여부 체크
      if (!is_main) {
        MessageAlert.warning('메인여부를 선택해주세요.');
        return false;
      }
      // 카테고리 체크
      if (!type){
        MessageAlert.warning('카테고리를 선택해주세요.');
        return false;
      }

      return {
        event_title: event_title,
        event_content: event_content,
        start_date: start_date ? Formatter.dateToUnix(start_date) : null,
        end_date: end_date ? Formatter.dateToUnix(end_date) : null,
        is_show: is_show,
        is_main: is_main,
        event_benefit: event_benefit,
        type: type,
      };
    }
  };

  /**
   * 이벤트 노출 순서 변경
   * --
   * @param {array} arr
   * @param {func} callback
   * @returns
   */
  const handleChangeOrder = async (arr = [], callback) => {
    if (!arr || !arr.length) return;

    const confirm = window.confirm('이벤트 노출 순서를 변경하시겠습니까?');

    if (!confirm) return;

    let isSuccess = false;
    try {
      setIsLoading(true);

      const updateData = arr.map((item) => ({
        event_id: item?.event_id,
        order: item?.order,
      }));
      const { status, data: eventList } = await upsertEvent(updateData);

      if (status !== 200) {
        MessageAlert.info('이벤트 순서변경에 실패하였습니다.');
        return;
      }

      MessageAlert.success('이벤트 노출 순서가 성공적으로 변경되었습니다.');
      isSuccess = true;

      const newData = eventList?.map((_item) => {
        const find = data?.find((d) => d?.event_id === _item?.event_id);

        return {
          ...find,
          order: _item?.order,
        };
      });
      setData(newData);
    } catch (err) {
      console.error('[handleChangeOrder] Error!! ', err);
      MessageAlert.error('이벤트 순서 변경에 실패하였습니다.');
    } finally {
      setTimeout(() => {
        setIsLoading(false);

        if (isSuccess) {
          callback();
        }
      }, 1000);
    }
  };

  /* ===== HOOKS ===== */
  /**
   * 모달 타입 초기화
   * --
   */
  useEffect(() => {
    if (!isOpened) setModalType('read');
  }, [isOpened]);

  /**
   * 데이터 초기화
   * --
   */
  useEffect(() => {
    const newData = Events?.data
      ?.map((event) => ({
        ...event,
        start_date: new Date(event?.start_date * 1000),
        end_date: new Date(event?.end_date * 1000),
        created_at: new Date(event?.created_at * 1000),
        updated_at: new Date(event?.updated_at * 1000),
      }))
      .sort((a, b) => b.created_at - a.created_at);
    setData(newData);
    // eslint-disable-next-line
  }, [Events]);
  // console.log('file', file);
  // console.log('data', data);
  /* ===== RENDER ===== */
  return (
    <>
      <EventListPresenter
        data={data}
        isCheckedAll={isCheckedAll}
        checkedList={checkedList}
        onChecked={handleChecked}
        onCheckedAll={setIsCheckedAll}
        isOpened={isOpened}
        modalData={modalData}
        modalType={modalType}
        onModalChange={setModalType}
        onClose={handleModalOpen}
        onOpen={handleModal}
        isRefetch={isRefetch}
        refetch={refetch}
        onChange={handleChange}
        onSubmit={handleSubmit}
        userInfo={userInfo}
        onDelete={handleDeleteSelected}
        file={file}
        onFileChange={setFile}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        onChangeOrder={handleChangeOrder}
      />
    </>
  );
};

export default EventListContainer;
